<template>
  <div class="duo-radio d-inline-block">
    <label class="c-input c-radio">
      <input
        type="radio"
        :value="valorOpcao1"
        :disabled="disabled"
        v-model="selecionado"
        @change="onChange"
      />
      <span class="c-indicator"></span> {{ labelOpcao1 }}
    </label>
    <label class="c-input c-radio">
      <input
        type="radio"
        :disabled="disabled"
        :value="valorOpcao2"
        v-model="selecionado"
        @change="onChange"
      />
      <span class="c-indicator"></span> {{ labelOpcao2 }}
    </label>
  </div>
</template>

<script>
export default {
  name: "HcDuoRadio",
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: null,
    disabled: {
      type: Boolean,
      default: false
    },
    labelOpcao1: {
      type: String,
      default: "Opção 1"
    },
    labelOpcao2: {
      type: String,
      default: "Opção 2"
    },
    valorOpcao1: {
      default: true
    },
    valorOpcao2: {
      default: false
    }
  },
  data,
  methods: {
    onChange
  },
  watch: {
    value
  }
};

function data() {
  return {
    selecionado: this.value
  };
}

function onChange() {
  this.$emit("input", this.selecionado);
  this.$emit("change", this.selecionado);
}

function value() {
  this.selecionado = this.value;
}
</script>
